import React, { useState, useEffect, memo, Suspense } from 'react';
import PlainModal from '../../../HtmlElements/PlainModal';
import SlicedCircle from '../../../HtmlElements/SlicedCircle';
import * as FeatherIcon from 'react-feather';
import { smartRevenueDisplay } from '../../../../services/commonService';
import RelevanceScore from '../../../HtmlElements/RelevanceScore';
import { useSelector } from 'react-redux';

const RevenueBox = ({ revenue }) => (
  <div className="icon_boxes purple pr-0">
    <div className="icon_block purple">
      <FeatherIcon.DollarSign className="fa" />
    </div>
    <p className="revenue_text">Revenue</p>
    <p className="number_text">$ {smartRevenueDisplay(revenue)}</p>
  </div>
);

const GrowthBox = ({ growthVal }) => (
  <div className="icon_boxes">
    <div className="icon_block blue">
      <FeatherIcon.TrendingUp className="icon_box_icon" />
    </div>
    <p className="revenue_text">Growth</p>
    <p className="number_text">{growthVal?.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 })} %</p>
  </div>
);

// const RelevanceScoreBox = ({ relevanceScore }) => (
//   <div className="icon_boxes">
//     <div className="icon_block green">
//       <SlicedCircle percentage={relevanceScore || 0} />
//     </div>
//     <p className="revenue_text">Relevance Score</p>
//     <p className="number_text">
//       <RelevanceScore relevanceScore={relevanceScore} section="" /> %
//     </p>
//   </div>
// );

const BusinessUnitOverview = memo(({ bu_unit, acc_bu_details ,keyFinData }) => {
  const [showDescriptionModal, setShowModal] = useState(false);
  const [buGrowthVal, setBuGrowthVal] = useState(null);
  const { bu_wise_revenue_analysis } = useSelector(state => state.fetchRevenueAnalysisReducer);
  const business_units = acc_bu_details?.business_units || [];
  const tempOverview = acc_bu_details?.business_unit_overview?.length ? acc_bu_details.business_unit_overview : '';

  useEffect(() => {
    if (bu_unit && bu_wise_revenue_analysis) {
      const buData = bu_wise_revenue_analysis.find(analysisData => analysisData.name === bu_unit);
      setBuGrowthVal(buData?.bu_revenue_growth || null);
    }
  }, [bu_unit, bu_wise_revenue_analysis]);

  const handleClose = () => setShowModal(false);

  if (!acc_bu_details?.business_unit_overview) {
    return null
  }

  return (
    <div className='generic-take-space-child '>
      <div className='business_unit_wrapper'>
      <div className={`custom_card_block ${keyFinData?.business_unit && "min-height-455"}`}>
          <div className='business_unit_block'>
            <h5 className='business_unit_head'>{bu_unit}</h5>
            <p className='business_unit_para'>
              <span>{acc_bu_details.business_unit_overview}</span>
            </p>
            <div className="row">
              <div className="col-md-4">
                {business_units?.revenue != null && <RevenueBox revenue={business_units.revenue} />}
              </div>
              <div className="col-md-4">
                {buGrowthVal != null && <GrowthBox growthVal={buGrowthVal} />}
              </div>
              {/* <div className="col-md-4">
                {business_units?.relevance_score != null && (
                  <RelevanceScoreBox relevanceScore={business_units.relevance_score} />
                )}
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <Suspense fallback={<div>Loading...</div>}>
        {showDescriptionModal && <PlainModal title={bu_unit} text={tempOverview} handleClose={handleClose} />}
      </Suspense>
    </div>
  );
});

export default BusinessUnitOverview;